module.exports = __webpack_public_path__ + "img/7-three.6642ddca.png";